module.exports = function (string) {
  return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&")
}



//////////////////
// WEBPACK FOOTER
// ./~/regexp-quote/regexp-quote.js
// module id = 438
// module chunks = 1 4 5 6 8 9 10 12 14 15 21 22 24 27 28 58